import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { FieldBlock } from './FieldBlock';
import { TextInput } from './TextInput';
import { FormErrorMessages } from './FormErrorMessages';
import { CheckboxInput } from './CheckboxInput';
import { Select } from './Select';
import { DatePickerInput } from './DatePickerInput';

export class InputBlock extends Component {
  getLabel = f => f + 'Label';

  renderHelpIcon() {
    if (this.props.help) {
      const tooltip = (
        <Tooltip id={this.props.toolTip} role="tooltip">{this.props.help}</Tooltip>
      );
      return (
        <OverlayTrigger placement="top" overlay={tooltip}>
          <a type="button" className="help-icon" data-toggle={this.props.toolTip}>
            <span className="fa fa-question-circle" aria-hidden="true"></span>
          </a>
        </OverlayTrigger>);
    }
    return null;
  }

  renderInput = (inputId, helpTextKey, hasHelpText) => {
    if (this.props.type === 'checkbox') {
      return (<CheckboxInput
        id={inputId}
        name={inputId}
        type={this.props.type}
        className="form-control"
        field={this.props.field}
        isInlineElement
        qaTag={this.props.qaTag}
        disabled={this.props.disabled}
      />);
    } else if (this.props.type === 'select') {
      return (<Select
        field={this.props.field}
        options={this.props.options}
        placeHolder={this.props.placeHolder}
        qaTag={this.props.qaTag}
        onChange={this.props.onChange}
        disabled={this.props.disabled}
        ariaLabelledBy={this.getLabel(this.props.field.input.name)}
        noEmptyOption={this.props.noEmptyOption}
      />);
    } else if (this.props.type === 'date') {
      return (<DatePickerInput
        field={this.props.field}
        qaTag={this.props.qaTag}
        onChange={this.props.onChange}
        disabled={this.props.disabled}
        ariaLabelledBy={this.getLabel(this.props.field.input.name)}
        language={this.props.language}
      />);
    }
    return (<TextInput
      id={inputId}
      name={inputId}
      type={this.props.type}
      className="form-control"
      field={this.props.field}
      isInlineElement
      {...(this.props.help) ? { ariaDescribedBy: helpTextKey } : {}}
      qaTag={this.props.qaTag}
      hasHelpText={hasHelpText}
      onChange={this.props.onChange}
      disabled={this.props.disabled}
      value={this.props.value}
      maxLength={ this.props.maxLength }
    />);
  }

  render() {
    let helpTextKey = '';
    let hasHelpText = false;
    if (this.props.hintText) {
      hasHelpText = true;
      helpTextKey = 'hlp_' + this.props.id + ' ';
    }

    if (this.props.toolTip) {
      hasHelpText = true;
      helpTextKey += this.props.toolTip;
    }

    if (helpTextKey[helpTextKey.length - 1] === ' ') {
      helpTextKey = helpTextKey.slice(0, -1);
    }
    const labelKey = 'label_' + this.props.id;
    const divKey = 'div_' + this.props.id;
    const inputId = this.props.id;
    return (
      <FieldBlock xsSize={this.props.xsSize} mdSize={this.props.mdSize}
        hidden={this.props.hidden} formGroup={this.props.formGroup }
      >
        <div key={divKey}>
          <label htmlFor={inputId} key={ labelKey } id={this.getLabel(this.props.field.input.name)}>
            {this.props.labelText}
            <FormErrorMessages field={this.props.field}
              ariaDescribedby={this.getLabel(this.props.field.input.name)}
              customMessage={this.props.customMessage}
            />
            &nbsp;
            { this.props.help ? this.renderHelpIcon() : null }
          </label>
          <p hidden id={this.props.toolTip}>{this.props.help}</p>
          { this.renderInput(inputId, helpTextKey, hasHelpText) }
          {this.props.hintText ?
            <span className="understated small" key={helpTextKey}>
              { this.props.hintText }
            </span> : null}
          {this.props.addtlElements || null}
        </div>
      </FieldBlock>);
  }
}

InputBlock.propTypes = {
  id: PropTypes.string,
  labelText: PropTypes.object,
  help: PropTypes.object,
  type: PropTypes.string,
  addtlElements: PropTypes.string,
  onChange: PropTypes.func,
  hintText: PropTypes.object,
  field: PropTypes.object,
  xsSize: PropTypes.number,
  mdSize: PropTypes.number,
  value: PropTypes.string,
  toolTip: PropTypes.string,
  hidden: PropTypes.bool,
  qaTag: PropTypes.string,
  options: PropTypes.array,
  placeHolder: PropTypes.string,
  formGroup: PropTypes.bool,
  disabled: PropTypes.bool,
  customMessage: PropTypes.object,
  language: PropTypes.string,
  maxLength: PropTypes.number,
  noEmptyOption: PropTypes.bool,
};
